var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
require('bootstrap/transition');
require('bootstrap/collapse');
require('fullcalendar');
var moment = require('moment');

function CalendarListing(el) {
	this.$el = $(el);

	var now = moment();
	var today = now.format('YYYY-MM-DD');

	this.$el.find(".js-calendar").each(function (index, el) {
		var $calendar = $(this);

		$calendar.fullCalendar({
			header: false,
			height: 'auto',
			fixedWeekCount: false,
			firstDay: 1,
			displayEventEnd: true,
			defaultView: 'basicWeek',
			defaultDate: $calendar.attr('data-date'),
			//slotDuration: '01:00',
			//minTime: '08:00:00',
			timeFormat: 'h:mm&#160;A',
			columnFormat: 'D dddd',
			events: $calendar.attr('data-feed'),
			eventRender: function (event, $el) {
				$el.addClass('calendar-week__event');
				$el.attr('data-category', event.category);
				$title = $el.find('.fc-title');
				$time = $el.find('.fc-time');
				$content = $el.find('.fc-content');

				// Fix character encoding
				$title.html($title.text());
				if (event.time_override) {
					$time.html(event.time_override);
				} else {
					$time.html($time.text());
				}

				// Switch content order
				$content.prepend($title);

				if (event.start.isBefore(now)) {
					$el.addClass('event-past');
				}

				if (event.show_talk) {
					$el.addClass('event-show-talk');
					$title.append('<span class="calendar-key__diamond"></span>');
				}

				if (event.sold_out) {
					$content.append('<span class="fc-sold-out"><em class="c-gray">Sold Out</em></span>');
				}
			},
			viewRender: function (view, $el) {
				$el.find('.fc-day-header').each(function (index, el) {
					var date = el.getAttribute('data-date');
					var d = date.split('-');
					var fmtDate = (d[2] === '01') ? 'MMM D' : 'D';
					var then = moment(date);

					var dateText = '<span class="date">' + then.format(fmtDate) + '</span>';
					dateText += ' <span class="weekday">' + then.format('dddd') + '</span>'

					$(el).html(dateText);

					if (date === today) {
						$(el).addClass('day-current');
					} else if (then.isBefore(now)) {
						$(el).addClass('day-past');
					}
				});

				if ($el.closest('.calendar-week').hasClass('calendar-week--blank')) {
					$el.append('<div class="calendar-week__blank-slate"><p class="small"><em>There are no events this week. Select future weeks to see what’s in store!</em></p></div>');
				}
			}
		});

		// Re-render calendars when resizing up from mobile view
		$(window).on('resize.jp-cal-' + index, function () {
			if ($calendar.is(':visible')) { // Desktop size

				if ($calendar.find('.fc-view').is(':empty')) { // Not yet rendered
					$calendar.fullCalendar('render');
				}

				$(window).off('resize.jp-cal-' + index);
			}
		})
	});

	this.$el.on('click', '.calendar-week__header', function (event) {
		var $this = $(this);
		var $target = $(event.target);
		var collapse = '.calendar-week__collapse';
		var notToggle = ($target.parents(collapse).length === 0 && !$target.is(collapse));

		if ( !$target.is('.calendar-week__performing-link') && notToggle ) {
			$this.find(collapse).click();
		}
		return;
	});

	this.$el.on('show.bs.collapse', '*', function () {
		var $week = $(this).closest('.calendar-week');
		$week.addClass('open')
			.find('.calendar-week__header h3').addClass('active');
	}).on('hide.bs.collapse', '*', function () {
		var $week = $(this).closest('.calendar-week');
		$week.removeClass('open')
			.find('.calendar-week__header h3').removeClass('active');
	});
}

module.exports = CalendarListing;


